export default defineNuxtRouteMiddleware((to, from) => {
  const { currentUserState } = useAuthState();

  if (!currentUserState.value) {
    return;
  }

  if (to.fullPath.startsWith('/app') || to.fullPath === '/app') {
    if (!currentUserState?.value?.agbConfirmedAt) {
      return navigateTo('/agb-bestaetigung');
    }
  } else if (to.fullPath === '/agb-bestaetigung') {
    if (currentUserState?.value?.agbConfirmedAt) {
      return navigateTo('/app');
    }
  }
});
